import { computed, type ComputedRef } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi';
import type { ComputedToursActivitiesData, ToursActivity } from '../types';
import { createToursActivitiesFromResource } from '@/entities/tour-activities/model/mapToursActivities';
import { useToursActivitiesLabels } from '../composable/useTourActivitiesLabels.ts';

export const useToursActivities = (): ComputedToursActivitiesData => {
  const { getToursActivities } = useExperienceApi();
  const { labelOf } = useToursActivitiesLabels();

  const { data } = useQuery({
    queryKey: ['toursActivities'],
    queryFn: async () => (await getToursActivities()).data ?? [],
  });

  const toursActivities: ComputedRef<ToursActivity[]> = computed(() => {
    const raw = data.value ?? [];

    return createToursActivitiesFromResource(raw, labelOf);
  });

  return { toursActivities };
};
